import { Grid } from "@mui/material";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { MprcNumberField } from "components/MprcNumberField";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IAdvFilterPickerProps, IAdvFilterResult } from "views/general/AdvancedFilter/interfaces";

////////////////////////////////////////////////////////////////////////////

export const DaysPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<number | null>(null);

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected != null) {
            const newFilter: IAdvFilterResult = {
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${selected}`,
                value: selected,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            };
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <MprcNumberField
                    autoFocus
                    value={selected}
                    min={0}
                    fullWidth={false}
                    defaultValue={1}
                    sx={{ width: 140 }}
                    onChange={(value) => setSelected(value)}
                    slotProps={{ input: { endAdornment: t("AdvFilter.Picker.Days.DaysText") } }}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected == null || selected == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
